<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     id: '',
     name: '',
     account_no: '',
     account_holder_name: '',
     ifsc: '',
     branch: '',
     image: null,
     show_remove: 0,
     image_preview: null,
    };
  },
  methods: {
   add(){
    this.resetForm();
    this.image_preview = null;
   },
   editBank(bank) {
    this.id = bank.id;
    this.name = bank.name;
    this.account_no = bank.account_no;
    this.account_holder_name = bank.account_holder_name;
    this.ifsc = bank.ifsc;
    this.branch = bank.branch;
    this.image_preview = bank.image ? bank.image_url : null; 
    this.show_remove = 0;
    if(bank.image !== null){
     this.show_remove = 1;
    }
   },  

   handleImageUpload(event){
    const file = event.target.files[0];
    this.image = file;
     if(file){
      this.image_preview = URL.createObjectURL(file);
     }else{
      this.image_preview = null;
     }
   },

   async addUpdateBank(){
    this.errors = {};
    this.setLoading(true); 

    try{
     const formData = new FormData();
      formData.append('id', this.id);
      formData.append('name', this.name);
      formData.append('account_no', this.account_no);
      formData.append('account_holder_name', this.account_holder_name);
      formData.append('ifsc', this.ifsc);
      formData.append('branch', this.branch);

      if(this.image){
       formData.append('image', this.image);
      } 

    let response = [];
    if(this.id){
      //UPDATE
      response = await axios.post('/banks/update', formData, {
      headers: { 'Content-Type': 'multipart/form-data',},
      });
    }else{
      //CREATE
      response = await axios.post('/banks/create', formData, {
      headers: { 'Content-Type': 'multipart/form-data',},
      });
    }
     
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.closeModal('bank_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteBank(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/banks/${this.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
    this.closeModal('delete_modal');
   }finally{
    this.setLoading(false);
   }
  }, 

  async removeFile(){
   const result = await this.$confirm({});
    if(result.isConfirmed){ 
   this.setLoading(true);
   try{
    const response = await axios.delete(`/banks/${this.id}/image/remove`);
    this.$swalToast(response.data.message);
    this.$emit('updated'); 
    this.closeModal('bank_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
   }
  },

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.name = '';
   this.account_no = '';
   this.account_holder_name = '';
   this.ifsc = '';
   this.branch = '';
   this.errors = {};
   this.image_preview = null;
  },

  },
};
</script>

<template>
  <!-- Add -->
  <div class="modal fade" id="bank_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Bank</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="addUpdateBank" enctype="multipart/form-data">
          <div class="modal-body pb-0">
            <div class="row">
              <div class="col-md-12">
              <div class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
              <div class="d-flex align-items-center justify-content-center avatar-xxl bg-white rounded border border-dashed me-2 flex-shrink-0 text-dark frames px-2">
              <img v-if="image_preview" :src="image_preview" class="img-fluid" alt="Image" width="70" />
              <i v-else class="ti ti-photo fs-24 text-muted"></i>
              </div>
              <div class="profile-upload">
              <div class="mb-2">
              <h6 class="mb-1">Image</h6>
              <p class="fs-12">Recommended: 250px x 250px</p>
              </div>
              <div class="profile-uploader d-flex align-items-center">
              <div class="drag-upload-btn btn btn-sm btn-primary me-2">
              Change
              <input type="file" class="form-control image-sign" @change="handleImageUpload"/>
              </div>

              <a href="javascript:void(0);" class="text-danger small" v-if="show_remove" @click="removeFile">Remove</a>
              
              </div>
              <div v-if="errors.image" class="text-danger small mt-1">{{ errors.image[0] }}</div>
              </div>
              </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Bank Name</label>
                  <input type="text" class="form-control" v-model="name" />
                  <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Account No</label>
                  <input type="text" class="form-control" v-model="account_no" />
                  <div v-if="errors.account_no" class="text-danger small mt-1">{{ errors.account_no[0] }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Account Holder Name</label>
                  <input type="text" class="form-control" v-model="account_holder_name" />
                  <div v-if="errors.account_holder_name" class="text-danger small mt-1">{{ errors.account_holder_name[0] }}</div>
                </div>
              </div> 

              <div class="col-md-3">
                <div class="mb-3">
                  <label class="form-label">IFSC Code</label>
                  <input type="text" class="form-control" v-model="ifsc" />
                  <div v-if="errors.ifsc" class="text-danger small mt-1">{{ errors.ifsc[0] }}</div>
                </div>
              </div> 

              <div class="col-md-9">
                <div class="mb-3">
                  <label class="form-label">Branch</label>
                  <input type="text" class="form-control" v-model="branch" />
                  <div v-if="errors.branch" class="text-danger small mt-1">{{ errors.branch[0] }}</div>
                </div>
              </div> 
              
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
            <button type="submit" class="btn btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete the item, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteBank">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>
